/**
 * Sticky Header
 */
(() => {
  const menubar = document.querySelector('.header-full');
  const menubarHeader = document.querySelector('header');
  if (!menubar || !menubarHeader) return;

  let lastScrollTop = 0;
  const stickyOffset = 100;
  const headNav = menubarHeader.querySelector('.head-nav-2');

  function stickyMenu() {
    if (document.body.classList.contains('ex-404') && menubar.classList.contains('container')) { return; }

    // change the 65 to the height of row above sticky (+ 15px for padding)
    const currentScrollTop = Math.max(0, Math.floor(window.pageYOffset));
    const isSticky = currentScrollTop >= stickyOffset;

    if (isSticky) {
      menubar.classList.add('menubarStick');
      menubarHeader.classList.add('menubarHeader');
    } else {
      menubar.classList.remove('menubarStick');
      menubarHeader.classList.remove('menubarHeader');
    }

    // Show/hide nav based on scroll direction (OfficeWise-style)
    if (headNav) {
      // When not sticky, keep the "show" state off.
      if (!isSticky) {
        headNav.classList.remove('show-head-nav');
      } else {
        // Default: hide on any scroll; only show when scrolling up.
        headNav.classList.remove('show-head-nav');
        if (currentScrollTop < lastScrollTop) {
          headNav.classList.add('show-head-nav');
        }
      }
    }

    lastScrollTop = currentScrollTop;
  }

  window.addEventListener('scroll', stickyMenu);
})();
